// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__9-fV5","show":"Overlay_show__LUV0C","hide":"Overlay_hide__n4Mf+","transparentBack":"Overlay_transparentBack__UrqN6"};